import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import SimpleCarousel from 'components/SimpleCarousel';
import {
  SPEED_DATING, MEETING, SPEED_DATING_MEETING, SPEED_DATING_RANDOM,
} from 'constants/types';
import { SPEED_DATING_DURATION, SPEED_DATING_REST } from 'constants/speed_dating';
import AgendaCard from 'components/Cards/AgendaCard';

function Agenda(props) {
  const {
    meetings, speedDatings, speedDatingMeetings, scheduleSpeedDatings, literals, title,
    showRandomSpeedDating, showPlanSpeedDating,
  } = props;

  const [elements, setElements] = useState([]);

  // Devuelve si el usuario esta libre a esa hora
  const isAvailable = (startTime, speedDatingEndTime) => {
    const MARGIN = 60; // Damos 60 segundos de margen
    const endTime = startTime + SPEED_DATING_DURATION + SPEED_DATING_REST + MARGIN;
    if (endTime > speedDatingEndTime) {
      return false;
    }
    let isBusy = false;

    const finalScheduleSpeedDatings = scheduleSpeedDatings.length ? scheduleSpeedDatings : speedDatingMeetings.filter((meeting) => {
      return speedDatings.find(speedDating => speedDating.id === meeting.element_id);
    });

    _.forEach(finalScheduleSpeedDatings, (meeting) => {
      if ((meeting.start_date >= startTime && meeting.start_date < endTime) || (meeting.end_date >= startTime && meeting.end_date < endTime)) {
        isBusy = true;
      }
    });

    if (isBusy) {
      return false;
    }

    // Devuelvo hasta que hora esta libre
    let availableUntil = null;
    _.forEach(finalScheduleSpeedDatings, (meeting) => {
      if (meeting.start_date > startTime && (!availableUntil || availableUntil > meeting.start_date)) {
        availableUntil = meeting.start_date;
      }
    });

    if (!availableUntil) {
      availableUntil = speedDatingEndTime;
    }

    return availableUntil;
  };

  useEffect(() => {
    const meetingsElements = meetings.map(meeting => ({
      type: MEETING,
      data: meeting,
    }));

    const speedDatingsElements = speedDatings.map(speedDating => ({
      type: SPEED_DATING,
      data: speedDating,
    }));

    const finalScheduleSpeedDatings = scheduleSpeedDatings.length ? scheduleSpeedDatings : speedDatingMeetings.filter((meeting) => {
      return speedDatings.find(speedDating => speedDating.id === meeting.element_id);
    });

    const scheduleSpeedDatingsElements = finalScheduleSpeedDatings.map(speedDating => ({
      type: SPEED_DATING_MEETING,
      data: speedDating,
    }));

    // Exclude events concluded
    const now = moment().unix();
    let allElementsToFilter = meetingsElements.concat(scheduleSpeedDatingsElements);
    if (showPlanSpeedDating) {
      allElementsToFilter = allElementsToFilter.concat(speedDatingsElements);
    }
    const allElements = _.filter(allElementsToFilter, (meeting) => {
      if (typeof meeting.data.status !== 'undefined' && meeting.data.status === 21275693) {
        return false;
      }

      const endDate = typeof meeting.data.end_date !== 'undefined' ? meeting.data.end_date : meeting.data.start_date + 3600 * 6;
      return endDate > now;
    });

    if (showRandomSpeedDating) {
      const actualTime = moment().unix();
      _.forEach(speedDatings, (speedDating) => {
        let randomMeetingsInserted = 0;
        if (speedDating.end_date > actualTime && randomMeetingsInserted < 2) {
          const startDate = Math.max(moment().unix(), speedDating.start_date);
          const endDate = speedDating.end_date;

          let iteratorDate = startDate;
          let availableUntil = false;
          let iteratorBreak = 0;
          while (iteratorDate < endDate && iteratorBreak < 1000) {
            // Compruebo si hay tiempo para un speed dating aleatorio
            availableUntil = isAvailable(iteratorDate, endDate);
            if (availableUntil) {
              const randomMeeting = { ...speedDating };
              randomMeeting.start_date = iteratorDate;
              randomMeeting.end_date = availableUntil;
              allElements.push({
                type: SPEED_DATING_RANDOM,
                data: randomMeeting,
              });

              iteratorDate = availableUntil;
              randomMeetingsInserted += 1;
            } else {
              iteratorDate += 60;
            }
            iteratorBreak += 1;
          }
        }
      });
    }

    allElements.sort((a, b) => {
      if (a.data.start_date === b.data.start_date) {
        if (a.type === SPEED_DATING) {
          return -1;
        }
        if (b.type === SPEED_DATING) {
          return 1;
        }
      }
      return a.data.start_date - b.data.start_date;
    });

    setElements(allElements);
  }, [meetings, speedDatings, speedDatingMeetings]);

  const printCards = () => {
    return elements.map((element, i) => {
      const newElement = { ...element };
      if (!newElement.data.element) {
        const aux = elements.find(e => e.id === element.id);
        if (aux) {
          newElement.data.element = aux.data.element;
          newElement.data.element_type = aux.data.element_type;
        }
      }

      return (
        <AgendaCard key={i} type={newElement.type} data={newElement.data} />
      );
    });
  };

  if (!elements.length) {
    return null;
  }

  return (
    <React.Fragment>
      <div className='title_section' dangerouslySetInnerHTML={{ __html: title || literals.scheduled }} />
      <SimpleCarousel classesList='agenda_card' showButtons>
        {printCards()}
      </SimpleCarousel>
    </React.Fragment>
  );
}

Agenda.propTypes = {
  literals: PropTypes.object.isRequired,
  title: PropTypes.string,
  meetings: PropTypes.array,
  speedDatings: PropTypes.array,
  speedDatingMeetings: PropTypes.array,
  scheduleSpeedDatings: PropTypes.array,
  showRandomSpeedDating: PropTypes.bool,
  showPlanSpeedDating: PropTypes.bool,
};

Agenda.defaultProps = {
  title: null,
  meetings: [],
  speedDatings: [],
  speedDatingMeetings: [],
  scheduleSpeedDatings: [],
  showRandomSpeedDating: true,
  showPlanSpeedDating: true,
};

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/Agenda/components/index.jsx